import { render } from "./SearchResultsComponent.vue?vue&type=template&id=703011e8"
import script from "./SearchResultsComponent.vue?vue&type=script&lang=ts"
export * from "./SearchResultsComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script